<template>
  <card-with-header-and-footer-component :loading="description.loading">
    <template v-slot:header>
      <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:line-clamp-2">{{ $t("customization.description") }}</h3>
      <!-- Hasta que el backend separe el texto del encabezado, el mismo campo se ve en un sitio u otro según el encabezado. -->
      <p class="mt-1 text-sm text-gray-500">{{ $t("customization.description_location_help") }}</p>
    </template>

    <tip-tap-editor-component v-model="description.request.description"></tip-tap-editor-component>

    <template v-slot:footer>
      <button type="button" v-on:click="getAcademyDescription" :disabled="description.loading" class="mr-2 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t("general.cancel") }}
      </button>

      <button type="button" v-on:click="setAcademyDescription" :disabled="description.loading" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-bpblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t("general.save") }}
      </button>
    </template>
  </card-with-header-and-footer-component>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import TipTapEditorComponent from "@/components/editor/TipTapEditorComponent";
import DescriptionService from "@/services/academy/DescriptionService";
import NotificationService from "@/services/notification/NotificationService";
import {useAuthUserStore} from "@/stores/auth";
import loadWhenAcademyReady from "@/mixins/loadWhenAcademyReady";

/*
 * Descripción de la academia (PUT /academy/description). Usa la academia del
 * usuario (authUserStore), que también llega vacía al recargar: se espera a la
 * academia seleccionada porque el store la pide después de cargar el usuario.
 */
export default {
  name: "DescriptionComponent",
  mixins: [loadWhenAcademyReady('getAcademyDescription')],
  components: {
    CardWithHeaderAndFooterComponent,
    TipTapEditorComponent,
  },
  setup(){
    const authUserStore = useAuthUserStore()

    return {
      authUserStore,
    }
  },
  data() {
    return {
      description: {
        loading: true,
        request: {
          description: ''
        }
      },
    }
  },
  methods: {
    getAcademyDescription() {
      let academy_uuid = this.authUserStore.user.academy.uuid;
      this.description.loading = true;

      DescriptionService.index(academy_uuid)
          .then((response) => {
            console.log("Se ha almacenado la descripción correctamente", response)
            this.description.request.description = response.data.description
          })
          .catch((response) => {
            console.log("Error obteniendo la descripción", response)
            NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
          })
          .finally(() => {
            this.description.loading = false
          })
    },
    setAcademyDescription() {
      let academy_uuid = this.authUserStore.user.academy.uuid;
      this.description.loading = true;

      DescriptionService.update(academy_uuid, this.description.request)
          .then((response) => {
            console.log("Se ha almacenado la descripción correctamente", response)
            NotificationService.showNotification("Se ha almacenado la descripción correctamente", "success")
          })
          .catch((error) => {
            console.log("Error guardando la descripción", error.response)
            if (error.response.data.errors)
            {
              error.response.data.errors.forEach( (error) => {
                NotificationService.showNotification(error, "error")
              })
            }
            else
            {
              NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
            }
          })
          .finally(() => {
            this.description.loading = false
          })
    },
  }
}
</script>
